export default __webpack_public_path__ + "static/media/DeckTP.a128753c.40d3cbb7.png";